export default {"src":"/_next/static/media/redact-list-bullet.2800d167.svg","height":28,"width":6,"blurWidth":0,"blurHeight":0};